'use client';

import moment from 'moment';
import { Modal } from 'react-bootstrap';
import { RatingView } from 'react-simple-star-rating';
import classes from './ReviewsModal.module.css';
import Image from 'next/image';
import { useSellerReviewsContext } from '@/context/sellerReviews';
import { X } from 'react-feather';

const ReviewsModal = (props) => {
	const { author, showReviewsModal, setShowReviewsModal, setPage, page } =
		props;

	const { sellerReviews } = useSellerReviewsContext();

	const abbreviateLastName = (fullName) => {
		const nameParts = fullName.split(' ');

		if (nameParts.length >= 2) {
			return `${nameParts[0]} ${nameParts[nameParts.length - 1].charAt(0)}.`;
		}

		return fullName;
	};

	return (
		<>
			<Modal
				show={showReviewsModal}
				onHide={() => setShowReviewsModal(!showReviewsModal)}
				className={classes.modal}
			>
				<div className={classes.main}>
					<X
						onClick={() => setShowReviewsModal(!showReviewsModal)}
						className={classes.closeIcon}
						strikeWidth={1}
					/>
					<section className={classes.colHeader}>
						<section className={classes.header}>
							<h2 className={classes.headerText}>Sales & Reviews</h2>
							{sellerReviews.reviews?.find((review) => review.id === author._id)
								?.averageReview > 0 && (
								<div className={classes.reviews}>
									<h5 className={classes.avg}>
										{sellerReviews.reviews
											?.find((review) => review.id === author._id)
											?.averageReview.toFixed(1)}
										/5
									</h5>
									<RatingView
										fillColor={'#632340'}
										className={classes.ratingView}
										size={20}
										ratingValue={sellerReviews.reviews
											?.find((review) => review.id === author._id)
											?.averageReview.toFixed()}
									/>
								</div>
							)}
						</section>
						{author?.shopInfo?.tags && author?.shopInfo?.tags.length > 0 && (
							<section className={classes.sellerTags}>
								{author.shopInfo.tags.map((tag, idx) => (
									<div key={idx} className={classes.tag}>
										✓ {tag}
									</div>
								))}
							</section>
						)}
					</section>
					<section className={classes.reviewsContainer}>
						{sellerReviews.reviews?.find((review) => review.id === author._id)
							?.reviews?.length > 0 &&
							sellerReviews.reviews
								?.find((review) => review.id === author._id)
								?.reviews?.map(
									(review, idx) =>
										review.order && (
											<li key={idx} className={classes.reviewContainer}>
												<h6 className={classes.firstName}>
													{abbreviateLastName(review.buyer.user.firstName)}
												</h6>
												<div className={classes.ratingsContainer}>
													{review.reviewed && review.seller.rating > 0 && (
														<RatingView
															fillColor={'#632340'}
															className={classes.ratingView}
															size={15}
															ratingValue={review.seller.rating}
														/>
													)}
													<h6 className={classes.mute}>
														{moment(review.order.date).format('MMM D, YYYY')}
													</h6>

													<div
														className={
															review?.order?.breakdown?.delivery > 0
																? classes.badge
																: classes.otherBadge
														}
													>
														{review?.order?.breakdown?.delivery > 0
															? 'Delivery'
															: 'Pick-up'}
													</div>
												</div>
												{review.reviewed &&
													review.seller.rating > 0 &&
													review.seller.feedback && (
														<div className={classes.reviewText}>
															&quot;{review.seller.feedback}&quot;
														</div>
													)}
												{review.listings?.length &&
													review.listings[0].listing?.images[0] &&
													review.listings.map((listing, idx) => (
														<div key={idx} className={classes.listingContainer}>
															<Image
																width={50}
																height={50}
																loading="lazy"
																src={listing?.listing?.images[0]}
																className={classes.listingImg}
																alt={listing?.listing?.title}
															/>
															<div className={classes.listingInfo}>
																<h6 className={classes.listingTitle}>
																	{listing?.listing?.title}
																</h6>
															</div>
														</div>
													))}
											</li>
										)
								)}

						{sellerReviews.reviews?.find((review) => review.id === author._id)
							?.totalCount >
							sellerReviews.reviews?.find((review) => review.id === author._id)
								?.reviews?.length && (
							<button
								className={classes.buttonPaginate}
								onClick={() =>
									sellerReviews?.loading ? console.log() : setPage(page + 1)
								}
							>
								{sellerReviews?.loading
									? 'Loading...'
									: 'VIEW MORE SALES & REVIEWS'}
							</button>
						)}
					</section>
				</div>
			</Modal>
		</>
	);
};

export default ReviewsModal;
